//     This code was generated by a Reinforced.Typings tool. 
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { GroupUserDto } from '../../group/dto/GroupUserDto';
import { PagedResultDto } from '../../shared/dto/PagedResultDto';
import { IApiRequest } from '../../IApiRequest';

export class GetGroupUsersRequest extends IApiRequest<PagedResultDto<GroupUserDto>>
{
	public $type = 'GetGroupUsersRequest';
	constructor(public data: { companyId: string, groupId: string, skip: number, take: number }) { super(); }
}
